import React from 'react';
import { Instagram, Linkedin } from 'lucide-react';
import { FaFacebookF } from 'react-icons/fa';
// import footerVector from '../../assets/Vector.svg';
import { Link, useLocation } from 'react-router-dom';
import { BsTwitterX } from "react-icons/bs";


const Footer = () => {

  const location = useLocation();

  const socialLinks = [
    { icon: FaFacebookF, href: '#', label: 'Facebook' },
    { icon: BsTwitterX, href: '#', label: 'X ' },
    { icon: Instagram, href: '#', label: 'Instagram' },
  ];


  const legalLinks = [
    { name: 'Disclaimer', path: '/Disclaimer' },
    { name: 'Privacy Policy', path: '/PrivacyPolicy' },
  ];

  const scrollToForm = () => {
    const formSection = document.getElementById('contactUs');
    formSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="flex flex-col">
      <footer className="bg-black text-white  relative overflow-hidden">
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="block md:hidden text-center">

            <div className="mt-4">
              <nav className="flex justify-between items-center mt-2 ">
                <div className="text-2xl font-bold text-white  font-[Quicksand]">
                  <div>
                    <Link to="/">
                      <h2 className="font-extrabold text-[25px]">Erexcel</h2>
                    </Link>
                  </div>
                </div>

                {/* Right side */}
                <div className="flex space-x-6">

                  <Link
                    to="/PrivacyPolicy"
                    className="font-[Quicksand] text-sm text-gray-300 hover:text-white  transition"
                  >
                    Privacy Policy
                  </Link>
                  <Link
                    to="/Disclaimer"
                    className="font-[Quicksand] text-sm text-gray-300 hover:text-white  transition"
                  >
                    Disclaimer
                  </Link>
                </div>
              </nav>


            </div>
          </div>

          {/* Desktop View */}
          <div className="hidden md:block">

            {/* Branding & Legal */}
            <div>
              <div className="flex flex-col sm:flex-row sm:justify-between items-center gap-4">
                <div className="text-3xl font-bold text-[#fffff] font-[Quicksand]">
                  <div>

                    <h2 className="font-extrabold text-[25px]">Erexcel</h2>

                  </div>
                </div>

                <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                  <nav className="flex gap-6">
                    {legalLinks.map((link) => (
                      <Link
                        key={link.name}
                        to={link.path}
                        className="text-sm text-gray-300 hover:text-white  transition"
                      >
                        {link.name}
                      </Link>
                    ))}
                  </nav>

                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;